import type { IconData } from '@stacksjs/iconify-core'

export const rowing: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M302.569 106.243A36 36 0 1 0 286.088 76a35.83 35.83 0 0 0 16.481 30.243M419.9 396.687L381.412 358.2l-11.375-11.375l-74.621-19.515L188.173 216h59.9L288 161.935v117.827l32.079 33.538L352 319.683V131.314h-81.167L231.926 184h-74.584l-33.82-35.1l-23.044 22.2l112.877 117.158L85.694 395.762l.779.925H16v32h232v-32H134.274l101.333-85.334l34.619 35.931l20.617 78.738l59.634 59.633a24 24 0 0 0 33.942 0l45.255-45.255l.1-.1a38.18 38.18 0 0 1 27.092-11.614H496v-32Zm-52.451 60.685L319.6 409.526l-12.036-45.963l45.979 12.025l47.844 47.844Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default rowing
